import { computed, toValue } from 'vue'
import type { MaybeRefOrGetter } from 'vue'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

import { checkSubscription, unsubscribe } from '../api'

import { subscriptionKeys } from './keys'

export function useSubscriptionStatus(token: MaybeRefOrGetter<string>) {
  const query = useQuery({
    queryKey: computed(() => subscriptionKeys.detail(toValue(token))),
    queryFn: ({ signal }) => checkSubscription(toValue(token), { signal }),
    enabled: computed(() => toValue(token).length > 0)
  })

  return {
    ...query,
    unsubscribed: computed(
      () => query.data.value?.data.data.unsubscribed ?? null
    )
  }
}

export function useUnsubscribe() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (token: string) => unsubscribe(token),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: subscriptionKeys.all })
    }
  })
}
